import { cva } from 'class-variance-authority';

export const chipVariants = cva(
  'inline-flex items-center gap-1 rounded-md border pl-2 pr-1 text-sm',
  {
    variants: {
      tone: {
        neutral: 'border-border bg-accent text-gray-600',
        removed: 'border-red-200 bg-red-50 text-red-400',
        // A value applied by configuration rather than by the user: tinted so it
        // reads as active at a glance without competing with user selections.
        preset: 'border-teal-300 bg-teal-50 text-teal-700',
      },
      size: {
        sm: 'py-1',
        md: 'py-1.5',
      },
    },
    defaultVariants: {
      tone: 'neutral',
      size: 'md',
    },
  },
);
